import React, { useState, useEffect } from 'react';
import EmailRoutingPathList from './EmailRoutingPathList'
import EmailRoutingPathMap from './EmailRoutingPathMap'
import CollapsibleCard from '../common/CollapsibleCard'
import { getReceivedFromGeoLocationsAsync } from "../../../helpers/geo"

export default function EmailRoutingPathCard() {
    const [geolocations, setGeolocations] = useState([]);
    useEffect(() => {
        async function getGeolocationsAsync() {
            const geo = await getReceivedFromGeoLocationsAsync();
            setGeolocations(geo);
        }
        getGeolocationsAsync();
      }, []);

    if(geolocations.length > 0){
      return (
          <CollapsibleCard header="Email Routing Path" ctrlName="emailRoutingPath" isOpen={true}>
                <p className="card-text">
                  The following map and text show the locations of the servers that the email was routed through before reaching the final destination.
                </p>
                <EmailRoutingPathMap geolocations={geolocations}></EmailRoutingPathMap>
                <EmailRoutingPathList geolocations={geolocations}></EmailRoutingPathList>
          </CollapsibleCard>
      );
    }
    else{
      return (
        <CollapsibleCard header="Email Routing Path" ctrlName="emailRoutingPath" isOpen={true}>
          <span className="font-weight-bold">
            No routing path locations found.
          </span>
        </CollapsibleCard>
      );
    }
  }
